<template>
  <div class="d-flex align-items-center justify-content-center w-100">
    <div class="sombra rounded-4 overflow-hidden" style="width: 90%; max-width: 400px;">
      <div class="d-flex align-items-center justify-content-center texto-secundario" style="height: 70px; background: linear-gradient(135deg, var(--goethe-accent), var(--goethe-accent-claro-2));">
        <div class="row">
          <div class="col-12 text-center">
            <h2 class="my-4">TreffPunkt</h2>
          </div>
        </div>
      </div>
      <div class="card-body p-4 fondo-secundario">
        <p class="fs-6 ms-1 text-center texto-secundario fw-semibold">{{ $t('porfavorLogin') }}:</p>
        <!-- El formulario debe apuntar al controlador Login y a la acción Login -->
          <div class="mt-2 d-flex flex-column gap-2">
            <div class="col-12 text-end">
              <a @click="loginGoogle" class="d-flex align-items-center justify-content-center flex-row btn btn-google rounded-pill form-control border borde-terciario fondo-terciario sombra" style="height: 45px">
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" style="display: block; height:20px; margin-right:8px;">
                  <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
                  <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path>
                  <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
                  <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
                  <path fill="none" d="M0 0h48v48H0z"></path>
                </svg>
                <p class="m-0 texto-secundario">{{ $t('loginGoogle') }}</p>
              </a>
            </div>
          </div>
        
        <svg xmlns="http://www.w3.org/2000/svg" class="d-none">
            <symbol id="exclamation-triangle-fill" viewBox="0 0 16 16">
                <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
            </symbol>
        </svg>
        <div class="alert alert-danger d-flex align-items-center mt-3 mb-0 p-1" v-if="errorMessage!=''" role="alert">
            <svg class="bi flex-shrink-0 mx-2" role="img" aria-label="Danger:" style="width:16px; height:16px"><use xlink:href="#exclamation-triangle-fill" /></svg>
            <p class="m-0">{{ errorMessage }}</p>
        </div>
        <div v-if="loading" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
          <img src="../assets/LOADING.gif" style="width: 30px;" alt="Cargando..." />
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
import { computed, reactive, ref, onMounted } from 'vue';
import { useRouter } from "vue-router";
import { API_BASE_URL } from '../config';
import {useStore} from "vuex";
import { googleSdkLoaded } from "vue3-google-login";
import axios from "axios";
import { useI18n } from 'vue-i18n';

export default{
  name: "LogIn",
  setup() {
    const data = reactive({
      email: '',
      password: ''
    });

    const { t } = useI18n();
    const errorMessage = ref('');
    const loading = ref(false); // Estado de cargado reactivo
    const router = useRouter();
    const store = useStore();
    const user = computed(() => store.state.user);
 
    const check = async () =>{
      if(localStorage.getItem('authToken')){
        await router.push('/'); // Redirige a la home page
      }
    }
    // Llama a esta función cuando el componente se monta
    onMounted(() => {
      const lastUpdate = localStorage.getItem("lastUpdate");
      const today = new Date().toISOString().split("T")[0]; // Obtiene solo la fecha (YYYY-MM-DD)

      if (lastUpdate !== today) {
        localStorage.setItem("lastUpdate", today);
        window.location.reload(); // Recarga la página solo si no se ha recargado hoy
      }
      check();
    });

    
    //Verificar cuenta microsoft y google al backend
    const saveData = async (data) => {
      try {
        localStorage.setItem('idForm', '');
        if ((data.jwtToken!=null)&&(data.jwtToken!='')) {

          localStorage.setItem('user', JSON.stringify(data.user));
          await store.dispatch('setUser', data.user);
          await store.dispatch('setAuth', true);
          localStorage.setItem('authToken', data.jwtToken);
          console.log(data)
          localStorage.setItem('refreshToken', data.refreshToken);
          localStorage.setItem('picture', data.picture);
          store.commit('SET_PIC', data.picture);
          
          if((data.user.dni == null || data.user.dni == '') && (data.user.pasaporte == null || data.user.pasaporte == '')){
            await router.push('/completarDatosBasicos');
          }
          else{
            //Debo extraer de la url la url de redireccion
            //const url = window.location.href; 
            // const cleanedUrlFirst = url.split("/login")[0];
            // const cleanedUrlFirstWithHash = url.split("/#/login")[0];
            // let cleanedUrl = ''
            // if(cleanedUrlFirstWithHash){
            //   cleanedUrl = cleanedUrlFirst;
            // }
            // else{
            //   cleanedUrl = cleanedUrlFirst+"/#/";
            // }
            
            let redirectUrl = localStorage.getItem('redirectAfterLogin') || '/';
            if(redirectUrl=="/login"){
              redirectUrl="/";
            }

            localStorage.removeItem('redirectAfterLogin');
            // Redirige al usuario
            await router.push(redirectUrl);

          }
        }
        else{
          console.error("Usuario no encontrado");
          errorMessage.value="Usuario no encontrado";
          await store.dispatch('setUser', data.user);
          loading.value = false;
        }
      } catch (error) {
        const axiosError = error;

        loading.value = false;  // Mostrar el cargador
        // Verificar si el error es un 404 Not Found
        if (axiosError.response && axiosError.response.status === 404) {
          console.error("Usuario no encontrado.");
          errorMessage.value="Usuario no encontrado";
        } else {
          // Manejar otros tipos de errores
          console.error("Error en la autenticación:", axiosError.message);
          errorMessage.value="Error en la autenticación:"+axiosError.message;
          loading.value = false;
        }
      }
    };

    //Login con Google
    const loginGoogle = async () => {
      try {
        googleSdkLoaded(google => {
          google.accounts.oauth2
            .initTokenClient({
              client_id: "500627635872-77hb2tnu32jgujk23f6qt51t5q4kqsqq.apps.googleusercontent.com",
              scope: "email profile openid",
              callback: async response => {
                if (response.access_token) {
                  loading.value = true;  // Mostrar el cargador
                  errorMessage.value = ""; // Limpiar mensaje de error previo
                  try{
                    const response2 = await axios.post(
                      `${API_BASE_URL}api/Account/google`,
                        {
                          Code: response.access_token,
                          RefererUrl: window.location.href
                        }
                    );
                    console.log(response2)
                    if(response2){
                      saveData(response2.data);
                    }
                    else{
                      errorMessage.value = 'Error en el inicio de sesion con Google';
                      console.error("Error en el inicio de sesion con Google");
                      loading.value = false;
                    }
                  }
                  catch(error){
                    const axiosError = error;
                    console.log("Error in Google login request:", axiosError); // Added log for debugging
                    if (axiosError.response && axiosError.response.status === 401) {
                      console.error("Usuario no Autorizado", axiosError.message+error);
                      errorMessage.value="Usuario no Autorizado";
                    } else if (axiosError.response && axiosError.response.status === 404) {
                      console.error("Usuario no encontrado (404)");
                      errorMessage.value="Usuario no encontrado";
                    } else {
                      console.error("Error en la autenticación:", axiosError.message);
                      errorMessage.value="Error en la autenticación: " + axiosError.message;
                    }
                    loading.value = false;
                  }
                }
              }
            })
            .requestAccessToken();
        });
      } catch (error) {
        const axiosError = error;

        loading.value = false;  // Mostrar el cargador
        if (axiosError.response && axiosError.response.status === 404) {
          console.error("Usuario no encontrado");
          errorMessage.value="Usuario no encontrado";
        } else {
          console.error("Error en la autenticación:", axiosError.message);
          errorMessage.value="Error en la autenticación:"+axiosError.message;
        }
      }
    };
    

    return {
      data,
      loginGoogle,
      loading,
      user,
      errorMessage,
      t,
    }
  },
}
</script>
